<template>
    <vs-popup title="Ajouter une question" :active.sync="isPromptActiveLocal">
        <vs-row style="margin-bottom:10px">
            <vs-col vs-type="flex" vs-w="6">
                <vs-input class="w-full" type="number" min="1" label="Points"
                          v-model="form.points"
                          :danger="error_data.points ? true : false"
                          :danger-text="error_data.points ? error_data.points[0] : ''"
                />
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col>
                <vs-textarea class="w-full" label="Instructions"
                             v-model="form.instructions"
                             :danger="error_data.instructions ? true : false"
                             :danger-text="error_data.instructions ? error_data.instructions[0] : ''"
                ></vs-textarea>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col>
                <vs-textarea class="w-full" label="Question"
                             v-model="form.question"
                             :danger="error_data.question ? true : false"
                             :danger-text="error_data.question ? error_data.question[0] : ''"
                ></vs-textarea>
                <span style="color:red; font-size: 10px" v-if="error_data.question">{{ error_data.question ? error_data.question[0] : '' }}</span>
            </vs-col>
        </vs-row>
        <vs-divider/>

        <vs-row>
            <vs-col>
                <div v-if="type == 'text'">
                    <vs-textarea class="w-full" label="Réponse correct"
                                 v-model="form.answers"
                                 :danger="error_data.answers ? true : false"
                                 :danger-text="error_data.answers ? error_data.answers[0] : ''"
                    />
                    <span style="color:red" v-if="error_data.answers">{{ error_data.answers ? error_data.answers[0] : '' }}</span>
                </div>
                <div v-else-if="type == 'checkbox'">
                    <span style="color:red" v-if="error_data.answers">{{ error_data.answers ? error_data.answers[0] : '' }}</span>
                    <div>
                        <span>Cliquer sur le boutton pour ajouter des réponses</span>
                    </div>
                    <table style="width:100%" v-if="form.answers && form.answers.length > 0">
                        <thead>
                        <th width="70%">Réponse</th>
                        <th width="20%">Correct</th>
                        <th width="10%"></th>
                        </thead>
                        <tbody>
                        <tr v-for="(item, key) in form.answers" :key="key">
                            <td>
                                <vs-textarea v-model="item.answers"
                                             :danger="error_data['answers.'+key+'.answers'] ? true : false"
                                             :danger-text="error_data['answers.'+key+'.answers'] ? 'Veuillez saisir une réponse' : ''"
                                             class="w-full"></vs-textarea>
                                <span style="color:red" v-if="error_data['answers.'+key+'.answers']">{{ error_data['answers.'+key+'.answers'] ? 'Veuillez saisir une réponse' : '' }}</span>
                            </td>
                            <td>
                                <input v-model="item.correct" type="checkbox" :id="'horns'+key" :name="item.correct">
                                Correct
                            </td>
                            <td>
                                <feather-icon @click="removeAnswers(item)"
                                              icon="TrashIcon"
                                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                              class="mr-2"
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <vs-row>
                        <vs-col vs-offset="10" vs-w="1">
                            <vs-button color="primary" @click="addAnswers()" size="small" type="border">Ajouter
                            </vs-button>
                        </vs-col>
                    </vs-row>
                </div>
                <div v-else>
                    <span style="color:red" v-if="error_data.answers">{{ error_data.answers ? error_data.answers[0] : '' }}</span>
                    <div>
                        <span>Cliquer sur le boutton pour ajouter des réponses</span>
                    </div>
                    <table style="width:100%" v-if="form.answers && form.answers.length > 0">
                        <thead>
                        <th width="70%">Réponse</th>
                        <th width="20%">Correct</th>
                        <th width="10%"></th>
                        </thead>
                        <tbody>
                        <tr v-for="(item, key) in form.answers" :key="key">
                            <td>
                                <vs-textarea v-model="item.answers"
                                             :danger="error_data['answers.'+key+'.answers'] ? true : false"
                                             :danger-text="error_data['answers.'+key+'.answers'] ? 'Veuillez saisir une réponse' : ''"
                                             class="w-full"></vs-textarea>
                                <span style="color:red" v-if="error_data['answers.'+key+'.answers']">{{ error_data['answers.'+key+'.answers'] ? 'Veuillez saisir une réponse' : '' }}</span>
                            </td>
                            <td>
                                <!-- <vs-radio :id="'radio'+key" v-model="item.correct" vs-name="radios1"
                                          @change="changeRadio(key)" :vs-value="item.correct"> Correct
                                </vs-radio> -->


                                <input @change="changeRadio(key)" type="radio" :name="'groups_' + key" v-bind:value="item.correct"
                                  v-bind:checked="item.correct == true"> Correct
                            </td>
                            <td>
                                <feather-icon @click="removeAnswers(item)"
                                              icon="TrashIcon"
                                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                              class="mr-2"
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <vs-row>
                        <vs-col vs-offset="10" vs-w="1">
                            <vs-button color="primary" @click="addAnswers()" size="small" type="border">Ajouter
                            </vs-button>
                        </vs-col>
                    </vs-row>
                </div>
            </vs-col>
        </vs-row>
        <br>
        <vs-button @click="add()" color="primary" type="filled">Enregistrer</vs-button>
    </vs-popup>
</template>

<script>
    const default_form = {
        points: 2,
        instructions: null,
        question: null,
        answers: null,
        questionnaire_id: '',
        type: '',
        difficulty_level: ''
    }
    export default {
        name: "add",
        props: {
            isPromptActive: {
                type: Boolean,
                required: true
            },
            type: {
                type: String,
                default: 'text'
            },
            addQuestion: {
                type: Function
            },
            nombreQuestion: {
                type: Number,
                default: 0
            },
            evaluation: {
                type: Object,
                default: {}
            },
            idQuestionnaire: {
                type: Number,
                default: 0
            },
        },
        data: () => ({
            error_data: [],
            form: {
                points: 2,
                instructions: null,
                question: null,
                answers: null,
                questionnaire_id: '',
                type: '',
                difficulty_level: ''
            }
        }),
        methods: {
            changeRadio(e) {
                if (this.form.answers.length > 0) {
                    for (let i = 0; i < this.form.answers.length; i++){
                        this.form.answers[i].correct = i === e;
                    }
                    
                }
            },
            addAnswers(model) {
                console.log(this.form.answers)
                if (Array.isArray(this.form.answers)) {
                    let index = this.form.answers.push({
                        answers: '',
                        correct: false,
                    })
                    //this.changeRadio(index -1)

                } else {
                    this.form.answers = []
                    this.form.answers.push({
                        answers: '',
                        correct: false,
                    })
                }

            },
            removeAnswers(model) {
                if (Array.isArray(this.form.answers)) {
                    let index = this.form.answers.indexOf(model)
                    this.form.answers.splice(index, 1)
                }
            },
            add() {
                //console.log(this.form)
                if (this.evaluation.nbr_question > this.nombreQuestion) {
                    this.$vs.loading()
                    this.form.questionnaire_id = this.idQuestionnaire
                    this.form.type = this.type
                    this.form.difficulty_level = this.evaluation.difficulty
                    this.$http.post('/questions/create', this.form).then((response) => {
                        window.getApp.success("Questionn ajouté", {})
                        this.addQuestion(response.data.model)
                        this.$vs.loading.close()
                        this.form = {...default_form}
                        this.error_data = []
                        this.$emit('closePrompt')
                    }).catch((error) => {
                        this.$vs.loading.close()
                        this.error_data = error.response.data.errors
                    })
                } else {
                    this.$vs.notify({
                        time: 30000,
                        title: 'Erreur!',
                        text: "Ce questionnaire ne peut avoir que " + this.evaluation.nbr_question + " question(s)",
                        color: 'danger',
                        iconPack: 'feather',
                        position: 'top-right',
                        icon: 'icon-check-circle'
                    })
                }
            }
        },
        watch: {
            isPromptActive(val) {
                if (!val) return;
            },
            /*
            input: {
                handler (val) {
                    base_self.watch_input_ajout_handler(val);
                },
                deep: true
            }
            */
        },
        computed: {
            isPromptActiveLocal: {
                get() {
                    this.form.points = 2;
                    this.form.instructions = null;
                    this.form.question = null;
                    this.form.answers = null;
                    this.form.questionnaire_id = '';
                    this.form.type = '';
                    this.form.difficulty_level = '';
                    return this.isPromptActive
                },
                set(val) {
                    if (!val) {
                        this.error_data = []
                        this.$emit('closePrompt')
                    }
                }
            },
        },
    }
</script>

<style scoped>

</style>
